import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Header1 } from 'src/components/shared/Typography/Header1';

const NotFound: React.FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header1>404</Header1>
      <p>
        {t('error.notFoundMessage')}. <Link to="/">{t('goback')}</Link>
      </p>
    </>
  );
};

export default NotFound;
